import axios from "axios";
import { buildAxiosConfig } from "./utils";
import Config from "../Config";
import ErrorMessage from "../libs/helpers/ErrorMessage";

export const getBrandEntityApi = async ({ headers, page }) => {
  try {
    const res = await axios.get(
      `${Config.apiBaseurl}/${Config.apis.brand.list}/entity`,
      buildAxiosConfig(headers),
    );
    return res.data;
  } catch (e) {
    if (e.response) {
      const { statusText, status, data } = e.response;
      const { httpStatus, clientType, description } = data;
      throw new ErrorMessage(
        statusText,
        description,
        httpStatus,
        status,
        clientType,
      );
    }
    throw e;
  }
};

export const getBrandListApi = async ({ headers, page, params = null }) => {
  try {
    const queryString = `pageNum=${page || 1}${
      params ? `&${params.join("&")}` : ""
    }`;
    const res = await axios.get(
      `${Config.apiBaseurl}/${Config.apis.brand.list}?${queryString}`,
      buildAxiosConfig(headers),
    );
    return res.data;
  } catch (e) {
    if (e.response) {
      const { statusText, status, data } = e.response;
      const { httpStatus, clientType, description } = data;
      throw new ErrorMessage(
        statusText,
        description,
        httpStatus,
        status,
        clientType,
      );
    }
    throw e;
  }
};

export const getBrandDuplicatesApi = async ({ headers, params = [] }) => {
  try {
    const res = await axios.get(
      `${Config.apiBaseurl}/${
        Config.apis.brand.list
      }/checkDuplicate?${params.join("&")}`,
      buildAxiosConfig(headers),
    );
    return res.data;
  } catch (e) {
    if (e.response) {
      const { statusText, status, data } = e.response;
      const { httpStatus, clientType, description } = data;
      throw new ErrorMessage(
        statusText,
        description,
        httpStatus,
        status,
        clientType,
      );
    }
    throw e;
  }
};

export const createBrandDetailApi = async ({ headers, data }) => {
  try {
    const res = await axios.post(
      `${Config.apiBaseurl}/${Config.apis.brand.detail}`,
      data,
      buildAxiosConfig(headers),
    );
    return res.data;
  } catch (e) {
    if (e.response) {
      const { statusText, status, data } = e.response;
      const { httpStatus, clientType, description } = data;
      throw new ErrorMessage(
        statusText,
        description,
        httpStatus,
        status,
        clientType,
      );
    }
    throw e;
  }
};

export const getBrandDetailApi = async ({ headers, id }) => {
  try {
    const res = await axios.get(
      `${Config.apiBaseurl}/${Config.apis.brand.detail}/${id}`,
      buildAxiosConfig(headers),
    );
    return res.data;
  } catch (e) {
    if (e.response) {
      const { statusText, status, data } = e.response;
      const { httpStatus, clientType, description } = data;
      throw new ErrorMessage(
        statusText,
        description,
        httpStatus,
        status,
        clientType,
      );
    }
    throw e;
  }
};

export const editBrandDetailApi = async ({ headers, id, data }) => {
  try {
    const res = await axios.put(
      `${Config.apiBaseurl}/${Config.apis.brand.detail}/${id}`,
      data,
      buildAxiosConfig(headers),
    );
    return res.data;
  } catch (e) {
    if (e.response) {
      const { statusText, status, data } = e.response;
      const { httpStatus, clientType, description } = data;
      throw new ErrorMessage(
        statusText,
        description,
        httpStatus,
        status,
        clientType,
      );
    }
    throw e;
  }
};

export const getBrandCompanyApi = async ({ headers, id }) => {
  try {
    const res = await axios.get(
      `${Config.apiBaseurl}/${Config.apis.company.detail}/${id}`,
      buildAxiosConfig(headers),
    );
    return res.data;
  } catch (e) {
    if (e.response) {
      const { statusText, status, data } = e.response;
      const { httpStatus, clientType, description } = data;
      throw new ErrorMessage(
        statusText,
        description,
        httpStatus,
        status,
        clientType,
      );
    }
    throw e;
  }
};
